import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { flattenTree, arrayToTree, getAllChildren } from 'utils/tree';
/**
 * Returns all selected content items, where selected
 * sections are replaced with their content.
 */

export function getImplicitlySelectedItems(_ref) {
  var content = _ref.content,
    selectedItemIds = _ref.selectedItemIds;
  var itemsContainSections = content.some(function (item) {
    return selectedItemIds.includes(item.id) && item.type === 'section';
  });

  // If the item ids
  if (!itemsContainSections) {
    return content.filter(function (item) {
      return selectedItemIds.includes(item.id);
    });
  }
  return selectedItemIds.flatMap(function (itemId) {
    var item = content.find(function (item) {
      return item.id === itemId;
    });
    if ((item === null || item === void 0 ? void 0 : item.type) === 'section') {
      return getAllChildren(content, itemId).filter(function (item) {
        return item.type !== 'section';
      });
    } else if (item) {
      return item;
    } else {
      return [];
    }
  });
}
export function getSelectionCompletionState(selectedItems) {
  if (selectedItems.length === 0) {
    return undefined;
  }
  if (selectedItems.every(function (item) {
    return item.optional;
  })) {
    return 'optional';
  } else if (selectedItems.every(function (item) {
    return !item.optional;
  })) {
    return 'required';
  } else {
    return 'mixed';
  }
}
export var sortByRank = function sortByRank(a, b) {
  return a.rankInSection - b.rankInSection;
};
export function getContentAsTree(content) {
  // Sorting items by the local rank within their containing section will result
  // in a correctly sorted tree after the `arrayToTree` conversion, but
  // note that `sortedItems` are not sorted in the context of the entire playlist
  var sortedItems = content.sort(sortByRank);
  return arrayToTree(sortedItems);
}
export function getRankedContentTree(_ref2) {
  var itemsAtThisLevel = _ref2.contentTree,
    _ref2$path = _ref2.path,
    path = _ref2$path === void 0 ? [] : _ref2$path;
  if (itemsAtThisLevel.length === 0) {
    return [];
  }
  return itemsAtThisLevel.map(function (item, index) {
    var currentPath = [].concat(_toConsumableArray(path), [index + 1]);
    var rank = currentPath.join('.');
    var itemWithRank = _objectSpread(_objectSpread({}, item), {}, {
      rank: rank,
      children: getRankedContentTree({
        contentTree: item.children,
        path: currentPath
      })
    });
    return itemWithRank;
  });
}
export function getIdsWithRank(rankedContentAsTree) {
  var flatTree = flattenTree(rankedContentAsTree);
  var ranksAndIds = {};
  flatTree.forEach(function (item) {
    ranksAndIds[item.id] = item.rank;
  });
  return ranksAndIds;
}
export function createInitialContentMap(initialContent) {
  var initialContentMap = {};
  initialContent.forEach(function (item) {
    initialContentMap[item.id] = item;
  });
  return initialContentMap;
}

/**
 * Determines if a playlist manager content item has unsaved changes
 * apart from those that only apply in the context of the playlist (e.g. optional).
 * Used for deciding if the item needs to be saved as its being removed from a playlist.
 */

export function wasContentItemDataChanged(item) {
  // We're ignoring 'optional' as that's a playlist-specific change
  if (item.changedFields.size === 1 && item.changedFields.has('optional')) {
    return false;
  }

  // This check should not be necessary as sections are playlist-specific.
  // Instead of passing a section to this function, pass in the section's content.
  if (item.type === 'section') {
    return false;
  }
  return item.changedFields.size > 0;
}